/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveNPAPTokensPriceProviderETH,
  CurveNPAPTokensPriceProviderETHInterface,
} from "../CurveNPAPTokensPriceProviderETH";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_providersRepository",
        type: "address",
      },
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nullAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeWrappedAddr",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CryptoPoolCantBeMetaPool",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyWETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNumberOfCoinsInPool",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolForLPTokenNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroPrice",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "LPTokenEnabled",
    type: "event",
  },
  {
    inputs: [],
    name: "TRICRYPTO2_LP_PRICE",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRICRYPTO2_LP_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isLPToken",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lpTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_lpTokens",
        type: "address[]",
      },
    ],
    name: "setupAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveNPAPTokensPriceProviderETHConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveNPAPTokensPriceProviderETHConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveNPAPTokensPriceProviderETH__factory extends ContractFactory {
  constructor(...args: CurveNPAPTokensPriceProviderETHConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveNPAPTokensPriceProviderETH";
  }

  deploy(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveNPAPTokensPriceProviderETH> {
    return super.deploy(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    ) as Promise<CurveNPAPTokensPriceProviderETH>;
  }
  getDeployTransaction(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    );
  }
  attach(address: string): CurveNPAPTokensPriceProviderETH {
    return super.attach(address) as CurveNPAPTokensPriceProviderETH;
  }
  connect(signer: Signer): CurveNPAPTokensPriceProviderETH__factory {
    return super.connect(signer) as CurveNPAPTokensPriceProviderETH__factory;
  }
  static readonly contractName: "CurveNPAPTokensPriceProviderETH";
  public readonly contractName: "CurveNPAPTokensPriceProviderETH";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveNPAPTokensPriceProviderETHInterface {
    return new utils.Interface(
      _abi
    ) as CurveNPAPTokensPriceProviderETHInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveNPAPTokensPriceProviderETH {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveNPAPTokensPriceProviderETH;
  }
}
